import { storeToRefs } from 'pinia';
import myAccountStore from './my-account-store';

const useMyOrganization = (loadImmediately = false, limit?: number) => {
  const store = myAccountStore();
  const { organizations, isLoading } = storeToRefs(store);
  const { loadMyOrganizations, reset } = store;
  const defaultLimit = 100;

  if (loadImmediately && !isLoading.value) {
    loadMyOrganizations(limit ?? defaultLimit, 0);
  }

  const loadAllOrganizations = async (offset?: number) => {
    await loadMyOrganizations(defaultLimit, offset ?? 0).catch(() => {
      console.error('Failed to load organizations');
    });
    if (organizations.value.meta.totalCount > organizations.value.data.length) {
      await loadAllOrganizations(organizations.value.data.length).catch(() => {
        console.error('Failed to load all organizations');
      });
    }
  };

  return {
    isLoading,
    loadMyOrganizations,
    loadAllOrganizations,
    organizations,
    reset,
  };
};

export default useMyOrganization;
